import React from 'react';

import * as S from './styles';

const Slide4: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Blusão, collab Felipe Fanaia com UMS-458, R$ 780.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide4 };
